var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('did-templates',{attrs:{"catalogid":_vm.catalogid,"catalog":_vm.catalog}}),_c('hr'),_c('claim-templates',{attrs:{"catalogid":_vm.catalogid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }